<div class="completeProfile-container">
  <app-mobile-header [title]="'complete.profile' | translate"></app-mobile-header>

  <div class="completeProfile-content">
    <div class="completeProfile-mascot">
      <img src="assets/generalImage/user.svg" loading="lazy" alt="mascot" />
      <h1 class="title" *ngIf="!isQueue">{{'desc.logged.in.now' | translate}}</h1>
      <h1 class="title" *ngIf="isQueue">{{"desc.complete.profile" | translate}}</h1>
      <h1 *ngIf="!isQueue">{{'desc.complete.profile.to.get.promotion.and.information' | translate}}</h1>
      <h1 *ngIf="isQueue">{{"desc.queue.register.profile" | translate}}</h1>
    </div>

    <form (ngSubmit)="onSubmit()" [formGroup]="fgroup" class="completeProfileform">

      <div class="completeProfile-name">
        <div class="input-outline" [ngClass]="{'invalid-p-inputtext': isRequiredFeild }">
          <span class="p-float-label">
            <input id="name" type="text" class="inputFielsTruncateText" pInputText formControlName="name" #name
              appInputTrim>
            <label for="name">{{'label.name' | translate}}</label>
          </span>
          <i class="icon-times" *ngIf="name.value" (click)="name.value = ''"></i>
          <i class="icon-alert" *ngIf="isRequiredFeild"></i>
        </div>

        <div class="invalid-feeback" *ngIf="isRequiredFeild">
          {{ 'label.required.field' | translate }}
        </div>
      </div>

      <label class="checkbox-container" (change)="onTickRegister($event)" *ngIf="isQueue && canRegister">
        <input type="checkbox" [value]="isQueueRegister" [checked]="isQueueRegister" />
        <span class="checkmark"></span>
        <span class="checkmark-desc">{{"desc.register.account" | translate}}</span>
      </label>

      <div class="completeProfile-email" *ngIf="(!isQueue) || (isQueue && isQueueRegister)">
        <div class="input-outline" [ngClass]="{'invalid-p-inputtext': f.email.errors?.pattern || displayError }">
          <span class="p-float-label">
            <input type="text" id="email" class="inputFielsTruncateText" pInputText formControlName="email" #email
              appInputTrim />
            <label for="email">{{'label.email' | translate}} ({{'label.optional' | translate}})</label>
          </span>
          <i class="icon-times" *ngIf="email.value" (click)="email.value = ''"></i>
          <i class="icon-alert" *ngIf="f.email.errors?.pattern || displayError"></i>
        </div>

        <div class="invalid-feeback" *ngIf="f.email.errors?.pattern">
          {{ 'error.invalid.email.format' | translate }}
        </div>

        <div class="invalid-feeback" *ngIf="displayError">
          {{ 'UserRegisterConflict_409' | translate : { ErrorField: errorField, ErrorMessage: errorMessage } }}
        </div>
      </div>

      <div class="input-outline" *ngIf="(!isQueue) || (isQueue && isQueueRegister)">
        <span class="p-float-label">
          <p-calendar formControlName="dob" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
            [yearRange]="'1900:' + maxYearRange" [maxDate]="maxDate" [touchUI]="true" [readonlyInput]="true"
            inputId="calendar" styleClass="CalenderStyle" id="dob">
          </p-calendar>
          <label for="dob">{{'label.date.of.birth' | translate}} ({{'label.optional' | translate}})</label>
        </span>
      </div>

      <app-button [buttonName]="'button.submit'" (onClickEvent)="onSubmit()" [disabled]="!fgroup.valid"></app-button>

      <app-termandprivacypolicy *ngIf="isQueue && canRegister"></app-termandprivacypolicy>
    </form>
  </div>
</div>

<p-dialog position="bottom" *ngIf="displayRegisterFailedMsg" [(visible)]="displayRegisterFailedMsg" [modal]="true"
  [dismissableMask]="true" [blockScroll]="true" styleClass="displayRegisterFailedMsg-dialog">
  <div class="register-failed-content">
    <i class="icon-alert"></i>
    <div class="register-failed-desc">
      <h1 class="title">{{"account.registration.failed" | translate}}</h1>
      <p class="desc">{{"desc.account.registration.failed" | translate}}</p>
    </div>

    <div class="action-container">
      <app-button [borderButton]="true" [buttonName]="'button.retry'" (onClickEvent)="closeFailedPopup()"
        class="tryAgain-btn"></app-button>
      <app-button [buttonName]="'button.proceed'" (onClickEvent)="proceedToQueue()" class="proceed-btn"></app-button>
    </div>
  </div>
</p-dialog>
